import { render } from "./CarouselInner.vue?vue&type=template&id=4c9d23dd"
import script from "./CarouselInner.vue?vue&type=script&lang=js"
export * from "./CarouselInner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Advanced/CarouselInner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c9d23dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c9d23dd', __exports__)) {
    api.reload('4c9d23dd', __exports__)
  }
  
  module.hot.accept("./CarouselInner.vue?vue&type=template&id=4c9d23dd", () => {
    api.rerender('4c9d23dd', render)
  })

}


export default __exports__